import { appSettingsHubAr } from './settingsHub.ar.js';
import { appOmgevingAr } from './omgevingApp.ar.js';
import { appRecurrenceAr } from './recurrenceApp.ar.js';
import { appDomeinAr } from './domeinApp.ar.js';
import { appMemorizeAr } from './memorizeApp.ar.js';
import { appSamenAr } from './samenApp.ar.js';
import { appCareAr } from './careApp.ar.js';
import { appCultureAr } from './cultureApp.ar.js';
import { appActivitiesAr, appChecklistAr } from './golf2App.ar.js';
import { appGrowthAr, appSchoolAr } from './groeiSchoolApp.ar.js';
import { appBoardConfigAr } from './boardConfigApp.ar.js';
import { appAgendaViewsAr, appHomeAr, appWeatherDetailAr } from './homeApp.ar.js';
import { appDevicesG4Ar, appEditorG4Ar, appPrivacyRightsAr } from './golf4App.ar.js';
import { appFeedsAr, appPlacesAr, appTravelAr } from './kaartApp.ar.js';
import { appLanguagesAr } from './languagesApp.ar.js';
import { appReadAloudAr } from './readAloudApp.ar.js';
import { appModulesAr } from './modulesApp.ar.js';
import { appHouseholdsAr } from './householdsApp.ar.js';
import { appProfileAr } from './profileApp.ar.js';
import { appPushAr } from './pushApp.ar.js';
import { appRemindersAr } from './remindersApp.ar.js';
import { appTodoAr } from './todoApp.ar.js';
import { appMissedAr } from './missedApp.ar.js';
import { appBillingAr } from './billingApp.ar.js';
import { appRidesAr } from './ridesApp.ar.js';
import { appTimePickerAr } from './timePicker.ar.js';
import { appVirtualDeviceAr } from './virtualDevice.ar.js';
import { appBoardViewAr } from './boardViewApp.ar.js';
import { appDailyAr } from './dailyApp.ar.js';
import { appThemesAr } from './themesApp.ar.js';
import { appGolf6Ar } from './golf6App.ar.js';
import { appWerklijstAr } from './werklijstApp.ar.js';
import { appChildConsentAr, appPrivacyStatementAr } from './golf5App.ar.js';
// Arabisch (ar): teksten van de ouder-webapp (zelfde vorm als app.nl.ts). Eenvoudig
// Standaardarabisch, vriendelijk en kort; AMUMIN blijft in Latijns schrift, getallen Latijns.
export const appAr = {
    // Golf 7 (0048): Soera's leren (memorizeApp.ar.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.ar.ts).
    domein: appDomeinAr,
    memorize: appMemorizeAr,
    // Golf 8 (0049): Samen wonen (samenApp.ar.ts).
    samen: appSamenAr,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.ar.ts).
    care: appCareAr,
    reminders: appRemindersAr,
    // 0058: to-do's zonder datum of tijd (todoApp.ar.ts).
    todo: appTodoAr,
    missed: appMissedAr,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.ar.ts).
    billing: appBillingAr,
    profile: appProfileAr,
    culture: appCultureAr,
    timePicker: appTimePickerAr,
    ridesPerDay: appRidesAr,
    modules: appModulesAr,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.ar.ts).
    households: appHouseholdsAr,
    checklist: appChecklistAr,
    activities: appActivitiesAr,
    languages: appLanguagesAr,
    readAloud: appReadAloudAr,
    // Golf 3-integratie: groei en school (0032), kaart en agenda (0034), werklijst, virtuele iPad (0028).
    growth: appGrowthAr,
    school: appSchoolAr,
    places: appPlacesAr,
    travel: appTravelAr,
    feeds: appFeedsAr,
    werklijst: appWerklijstAr,
    virtualDevice: appVirtualDeviceAr,
    // Menu Board: het echte bord live bekijken (boardViewApp.ar.ts).
    boardView: appBoardViewAr,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.ar.ts).
    daily: appDailyAr,
    themes: appThemesAr,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.ar.ts).
    home: appHomeAr,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.ar.ts).
    boardConfig: appBoardConfigAr,
    agendaViews: appAgendaViewsAr,
    weatherDetail: appWeatherDetailAr,
    golf6: appGolf6Ar,
    // 0036: Jouw gegevens (golf 4).
    privacyRights: appPrivacyRightsAr,
    // Instellingen als overzicht (settingsHub.ar.ts).
    settingsHub: appSettingsHubAr,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.ar.ts).
    omgeving: appOmgevingAr,
    // Herhaling in gewone taal (recurrenceApp.ar.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceAr,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.ar.ts).
    childConsent: appChildConsentAr,
    privacyStatement: appPrivacyStatementAr,
    // 0038: meldingen op je telefoon (pushApp.ar.ts).
    push: appPushAr,
    nav: {
        // 0060: module Notities.
        notes: 'الملاحظات',
        // 0064: module Fotolijst.
        photos: 'إطار الصور',
        kompas: 'وزن صحي',
        // 0069: module Geldzaken (privé).
        money: 'الشؤون المالية',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: 'مهامي اللاحقة',
        today: 'اليوم',
        board: 'اللوحة',
        agenda: 'الأجندة',
        tasks: 'المهام',
        rewards: 'المكافآت',
        approvals: 'الموافقات',
        members: 'العائلة',
        devices: 'الأجهزة اللوحية',
        settings: 'الإعدادات',
        security: 'الأمان',
        household: 'إعداد البيت',
        rides: 'التوصيلات',
        more: 'المزيد',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'لوحة الملاحظات',
        children: 'الأطفال',
        together: 'معًا',
        boardHub: 'اللوحة',
        boardView: 'العرض',
        stars: 'النجوم',
        membersTab: 'الأعضاء',
        circle: 'الدائرة',
        forYou: 'لك',
        forYouWaiting: 'بانتظار الموافقة: {n}',
        menu: 'القائمة',
        logout: 'تسجيل الخروج',
        main: 'القائمة الرئيسية',
        skip: 'إلى المحتوى',
        growth: 'النمو',
        school: 'المدرسة',
        admin: 'الإدارة',
        werklijst: 'قائمة العمل',
    },
    common: {
        save: 'حفظ',
        cancel: 'إلغاء',
        delete: 'حذف',
        edit: 'تعديل',
        add: 'إضافة',
        close: 'إغلاق',
        back: 'رجوع',
        next: 'التالي',
        later: 'لاحقًا',
        undo: 'تراجع',
        retry: 'حاول مرة أخرى',
        info: 'شرح',
        moreCount: '+{n} أخرى',
        loading: 'لحظة، جارٍ التحميل…',
        optional: 'اختياري',
        yes: 'نعم',
        no: 'لا',
        none: 'لا شيء',
        everyone: 'الجميع',
        minutes: {
            zero: '{count} دقيقة',
            one: 'دقيقة واحدة',
            two: 'دقيقتان',
            few: '{count} دقائق',
            many: '{count} دقيقة',
            other: '{count} دقيقة',
        },
        minutesShort: '{count} د',
        hoursMinutes: '{h} س {m} د',
        hours: {
            zero: '{count} ساعة',
            one: 'ساعة واحدة',
            two: 'ساعتان',
            few: '{count} ساعات',
            many: '{count} ساعة',
            other: '{count} ساعة',
        },
        points: {
            zero: '{count} نقطة',
            one: 'نقطة واحدة',
            two: 'نقطتان',
            few: '{count} نقاط',
            many: '{count} نقطة',
            other: '{count} نقطة',
        },
        by: 'بواسطة {name}',
        unknown: 'غير معروف',
        errorLoad: 'لم ينجح هذا الآن. حاول مرة أخرى.',
        savedOk: 'تم الحفظ',
    },
    offline: 'لا يوجد اتصال بالخادم. سنحاول مرة أخرى تلقائيًا.',
    today: {
        goodMorning: 'صباح الخير',
        goodAfternoon: 'نهارك سعيد',
        goodEvening: 'مساء الخير',
        goodNight: 'ليلة سعيدة',
        week: 'الأسبوع {week}',
        next: 'بعد قليل',
        now: 'يجري الآن',
        startsIn: 'بعد {time}',
        endsIn: 'باقي {time}',
        nothingNext: 'لا شيء مخطط بعد الآن اليوم',
        nothingNextBody: 'وقت لبعضكم.',
        agenda: 'أجندة اليوم',
        addEvent: 'موعد',
        addEventLong: 'إضافة موعد',
        tasks: 'مهام اليوم',
        tasksAll: 'كل المهام',
        noTasks: 'لا مهام اليوم',
        approvals: 'الموافقات',
        approvalsWaiting: {
            zero: 'لا شيء ينتظرك',
            one: 'شيء واحد ينتظرك',
            two: 'شيئان ينتظرانك',
            few: '{count} أشياء تنتظرك',
            many: '{count} شيئًا ينتظرك',
            other: '{count} شيء ينتظرك',
        },
        approvalsView: 'عرض',
        ridesOpen: {
            zero: 'لا توصيلات بلا سائق',
            one: 'توصيلة واحدة بلا سائق',
            two: 'توصيلتان بلا سائق',
            few: '{count} توصيلات بلا سائق',
            many: '{count} توصيلة بلا سائق',
            other: '{count} توصيلة بلا سائق',
        },
        ridesAll: 'كل التوصيلات',
        tomorrow: 'غدًا',
        tomorrowNothing: 'لا شيء في الغد بعد.',
        toAgenda: 'إلى الأجندة',
        goalsTitle: 'الادخار',
    },
    agenda: {
        title: 'الأجندة',
        prev: 'السابق',
        next: 'التالي',
        today: 'اليوم',
        newEvent: 'موعد',
        filter: 'اعرض لـ',
        filterAll: 'الجميع',
        emptyDay: 'لا شيء مخطط في هذا اليوم بعد',
        emptyDayBody: 'اضغط على + لإضافة شيء.',
        emptyWeek: 'لا شيء مخطط هذا الأسبوع بعد',
        emptyRange: 'لا شيء مخطط بعد',
        weekTitle: 'الأسبوع {week} · {range}',
        trash: 'سلة المحذوفات',
        trashIntro: 'تُحفظ المواعيد المحذوفة 30 يومًا.',
        trashEmpty: 'سلة المحذوفات فارغة.',
        restore: 'استرجاع',
        restoreUntil: 'يمكن استرجاعه حتى {date}',
        restored: '{title} في الأجندة من جديد',
        restoreExpired: 'حُذف هذا الموعد منذ أكثر من 30 يومًا ولا يمكن استرجاعه.',
        export: 'تصدير الأجندة',
        exportIntro: 'نزّل الأجندة كملف .ics لهاتفك أو حاسوبك.',
        exportHousehold: 'العائلة كلها',
        moved: 'نُقل {title} إلى {when}',
        moveFailed: 'لم ينجح النقل. عاد الموعد إلى مكانه.',
        dragHint: 'اسحب موعدًا لنقله.',
        allDay: 'طوال اليوم',
        moreItems: '+{count} أخرى',
    },
    event: {
        when: 'متى',
        leave: 'الانطلاق',
        who: 'من',
        where: 'أين',
        notes: 'ملاحظة',
        repeats: 'التكرار',
        rides: 'التوصيل والإرجاع',
        dropoff: 'التوصيل',
        pickup: 'الإرجاع',
        driverOpen: 'من يقود؟',
        driverIs: 'يقود: {name}',
        iDrive: 'أنا أقود',
        chooseDriver: 'اختر من يقود',
        nobody: 'لا أحد بعد',
        driverSaved: 'يقود: {name}',
        driverCleared: 'أُزيل السائق',
        depart: 'الانطلاق {time}',
        travel: '{count} د في الطريق',
        edit: 'تعديل',
        cancelOne: 'إلغاء هذه المرة',
        cancelledOne: '{title} لن يُقام هذه المرة',
        cancelled: 'أُلغي',
        restoreOne: 'إقامته رغم ذلك',
        restoredOne: '{title} سيُقام رغم ذلك',
        resetOne: 'العودة إلى الموعد العادي',
        resetDone: 'هذه المرة عادت كما في السلسلة',
        resetKeptRide: 'هذه المرة عادت كما في السلسلة. من يقود يبقى كما رتّبته لهذه المرة.',
        resetKeptReminder: 'هذه المرة عادت كما في السلسلة. التذكير المتخطّى يبقى صامتًا هذه المرة.',
        resetKeptBoth: 'هذه المرة عادت كما في السلسلة. من يقود والتذكير المتخطّى يبقيان كما رتّبتهما لهذه المرة.',
        moved: 'تغيّر موعده',
        changed: 'تغيّر',
        delete: 'حذف',
        deleted: 'حُذف {title}',
        deleteTitle: 'حذف {title}؟',
        deleteBody: 'يمكنك استرجاعه من سلة المحذوفات خلال 30 يومًا.',
        duplicate: 'نسخ',
        duplicated: 'تم إنشاء نسخة',
        history: 'ماذا تغيّر؟',
        historyEmpty: 'لا تغييرات بعد.',
        historyItem: '{who} · {when}',
        conflict: 'في نفس وقت شيء آخر',
        conflictWith: {
            zero: 'لدى {names} أيضًا {title} في ذلك الوقت',
            one: 'لدى {names} أيضًا {title} في ذلك الوقت',
            two: 'لدى {names} أيضًا {title} في ذلك الوقت',
            few: 'لدى {names} أيضًا {title} في ذلك الوقت',
            many: 'لدى {names} أيضًا {title} في ذلك الوقت',
            other: 'لدى {names} أيضًا {title} في ذلك الوقت',
        },
        conflictDrive: '{name} يقود الساعة {time} ولديه حينها أيضًا {title}',
        lastChanged: 'آخر تعديل بواسطة {name}',
        notFound: 'هذا الموعد لم يعد موجودًا.',
        action: {
            create: 'أُنشئ',
            update: 'عُدّل',
            delete: 'حُذف',
            restore: 'استُرجع',
            split: 'عُدّل من هنا فصاعدًا',
            cancel: 'أُلغي',
            uncancel: 'سيُقام رغم ذلك',
            move: 'نُقل',
            override: 'عُدّل لهذه المرة',
            override_clear: 'عاد كما في السلسلة',
            role: 'تغيّر السائق',
        },
    },
    editor: {
        ...appEditorG4Ar,
        newTitle: 'موعد جديد',
        editTitle: 'تعديل الموعد',
        title: 'ماذا',
        titlePlaceholder: 'مثلًا: درس السباحة',
        titleHint: 'قصير وواضح، مثلًا: درس السباحة',
        templates: 'اختيار سريع',
        picto: 'الرمز',
        pictoChoose: 'اختر رمزًا',
        pictoChange: 'رمز آخر',
        who: 'لمن',
        everyone: 'الجميع',
        date: 'التاريخ',
        allDay: 'طوال اليوم',
        start: 'من',
        end: 'إلى',
        duration: 'المدة',
        endDate: 'حتى (ضمنًا)',
        endBeforeStart: 'وقت الانتهاء قبل وقت البداية.',
        repeat: 'التكرار',
        repeatNone: 'بدون تكرار',
        repeatDaily: 'كل يوم',
        repeatWeekly: 'كل أسبوع',
        repeatBiweekly: 'كل أسبوعين',
        repeatMonthly: 'كل شهر',
        repeatYearly: 'كل سنة',
        onDays: 'في أي أيام',
        monthlyHow: 'أي يوم من الشهر',
        monthlyDay: 'في اليوم {day}',
        monthlyLast: 'في آخر يوم',
        monthlyNth: 'في {weekday} {ordinal} من الشهر',
        ordinal: {
            '1': 'الأول',
            '2': 'الثاني',
            '3': 'الثالث',
            '4': 'الرابع',
            '-1': 'الأخير',
        },
        parity: 'أي أسابيع',
        parityAll: 'كل الأسابيع',
        parityEven: 'الأسابيع الزوجية',
        parityOdd: 'الأسابيع الفردية',
        ends: 'ينتهي',
        endsNever: 'أبدًا',
        endsCount: 'بعد عدد من المرات',
        endsUntil: 'في تاريخ',
        count: 'عدد المرات',
        until: 'حتى (ضمنًا)',
        nextDates: 'المرات القادمة',
        rides: 'التوصيل والإرجاع',
        ridesHint: 'من يوصل ومن يُرجع؟ اختر «غير معروف بعد» إن لم تكن تعرف.',
        dropoff: 'التوصيل',
        pickup: 'الإرجاع',
        roleNone: 'لا حاجة',
        roleOpen: 'مفتوح (من يقود؟)',
        travel: 'مدة الطريق',
        travelNone: 'لا شيء',
        travelOwn: 'وقت آخر…',
        travelOwnLabel: 'وقت الطريق بالدقائق',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'وقت العودة',
        travelBackHint: 'نفس وقت الطريق بعد الموعد أيضًا، للعودة إلى البيت.',
        travelAuto: 'تلقائي (حسب المكان)',
        travelAutoWith: 'تلقائي ({minutes} دقيقة)',
        departureAlert: 'تنبيه للانطلاق',
        departureAlertHint: 'تعرض اللوحة متى يجب أن تنطلق.',
        departureNone: 'بلا تنبيه',
        departureBefore: 'قبل {count} د',
        location: 'أين',
        locationPlaceholder: 'مثلًا: المسبح',
        notes: 'ملاحظة',
        notesPlaceholder: 'خذ حقيبة السباحة والمنشفة',
        category: 'النوع',
        more: 'خيارات أخرى: التوصيل والإرجاع، المكان، ملاحظة',
        less: 'خيارات أقل',
        fullScreen: 'ملء الشاشة',
        smallScreen: 'تصغير',
        create: 'حفظ الموعد',
        save: 'حفظ',
        created: '{title} في الأجندة الآن',
        saved: 'تم حفظ الموعد',
        conflictNotice: {
            zero: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
            one: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
            two: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
            few: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
            many: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
            other: 'لدى {names} أيضًا {title} في ذلك الوقت ({time}).',
        },
        orphansTitle: 'توجد تعديلات منفصلة',
        orphansBody: 'عدّلت بعض المرات بشكل منفصل، وستُلغى الآن. ماذا تريد أن تفعل بها؟',
        orphansKeep: 'احفظها كمواعيد منفصلة',
        orphansDelete: 'احذفها',
        onlyThisNoRepeat: 'التكرار تغيّره لهذه المرة والمرات التالية أو للسلسلة كلها.',
        titleRequired: 'اكتب ما هو.',
        memberRequired: 'اختر لمن هو.',
        categories: {
            sport: 'رياضة',
            school: 'مدرسة',
            medisch: 'طبيب وطبيب أسنان',
            sociaal: 'لقاء',
            werk: 'عمل',
            verjaardag: 'عيد ميلاد',
            overig: 'أخرى',
        },
    },
    scope: {
        thisHint: '{date} فقط',
        followingHint: 'من {date}',
        allHint: 'كل المرات، والسابقة أيضًا',
        deleteFollowing: 'حذف هذه والتالية',
        confirm: 'متابعة',
    },
    rides: {
        title: 'التوصيلات',
        subtitle: 'من يوصل ومن يُرجع من، في الأسبوع القادم.',
        open: 'لا سائق بعد',
        arranged: 'مرتّبة',
        empty: 'كل التوصيلات مرتّبة.',
        emptyBody: 'لا أحد يحتاج إلى البحث عن توصيلة.',
        none: 'لا توصيلات هذا الأسبوع.',
        noneBody: 'حدّد في الموعد من يوصل أو يُرجع، فيظهر هنا.',
        iDrive: 'أنا أقود',
        choose: 'اختر',
        dropoff: 'التوصيل',
        pickup: 'الإرجاع',
        notLinked: 'حسابك غير مربوط بأحد أفراد العائلة بعد. اختر أدناه من يقود.',
    },
    tasks: {
        title: 'المهام',
        viewToday: 'اليوم',
        viewWeek: 'الأسبوع',
        viewAll: 'الكل',
        add: 'مهمة',
        addLong: 'إضافة مهمة',
        newTitle: 'مهمة جديدة',
        editTitle: 'تعديل المهمة',
        library: 'أفكار للمهام',
        libraryIntro: 'اختر مهمة ولمن هي. النقاط تناسب العمر.',
        libraryAdd: 'إضافة',
        libraryFor: 'لمن',
        what: 'ماذا',
        titlePlaceholder: 'مثلًا: تجهيز المائدة',
        who: 'لمن',
        mode: 'كيف',
        modeEach: 'كل واحد وحده',
        modeEachHint: 'كل واحد يقوم بها بنفسه ويحصل على نقاطه.',
        modeTogether: 'معًا',
        modeTogetherHint: 'تقومون بها معًا؛ علامة واحدة للجميع.',
        modeFirst: 'من يسبق',
        modeFirstHint: 'من يقوم بها أولًا يحصل على النقاط.',
        repeat: 'كم مرة',
        repeatOnce: 'مرة واحدة',
        repeatDaily: 'كل يوم',
        repeatWeekdays: 'أيام الدوام',
        repeatWeekly: 'كل أسبوع',
        repeatMonthly: 'كل شهر',
        onDays: 'في أي أيام',
        monthDay: 'في اليوم',
        monthLast: 'آخر يوم',
        startDate: 'من',
        date: 'في',
        dueDate: 'قبل',
        timeOfDay: 'متى في اليوم',
        tod: {
            any: 'طوال اليوم',
            morning: 'الصباح',
            afternoon: 'بعد الظهر',
            evening: 'المساء',
        },
        dueTime: 'تنتهي الساعة',
        points: 'النقاط',
        pointsHint: 'كم نجمة تستحق؟ 0 مسموح أيضًا.',
        approval: 'تحتاج موافقة',
        approvalHint: 'يوافق بابا أو ماما على المهمة قبل احتساب النقاط.',
        approvalHintNoPoints: 'يراجع بابا أو ماما المهمة قبل أن تُحسب منجزة.',
        description: 'شرح',
        create: 'حفظ المهمة',
        created: '{title} جاهزة',
        saved: 'تم حفظ المهمة',
        deleteTitle: 'حذف {title}؟',
        deleted: 'حُذفت {title}',
        duplicateTitle: 'هذه المهمة موجودة بالفعل',
        duplicateBody: 'توجد بالفعل مهمة {title} لـ {names}. هل تضيف واحدة أخرى؟',
        addAnyway: 'أضف رغم ذلك',
        emptyTitle: 'لا مهام بعد',
        emptyBody: 'ابدأ بشيء صغير، مثل تنظيف الأسنان.',
        emptyToday: 'لا مهام اليوم',
        emptyTodayBody: 'تظهر مهام اليوم هنا.',
        progress: '{done} من {total} تمّت',
        completeFor: 'شطب لـ {name}',
        completed: 'شُطبت {title}',
        revert: 'إعادتها مفتوحة',
        reverted: '{title} مفتوحة من جديد',
        skip: 'تخطٍّ',
        skipped: 'تُخطّيت {title}',
        unskip: 'القيام بها رغم ذلك',
        state: {
            open: 'مفتوح',
            done: 'تمّت',
            pending: 'تنتظر الموافقة',
            rejected: 'مرة أخرى',
            skipped: 'تُخطّيت',
            missed: 'فاتت',
        },
        late: 'باقية من أمس',
        next: 'المرة القادمة: {date}',
        noNext: 'لا مرة قادمة',
        together: 'معًا',
        negativeTitle: 'النقاط ستصبح تحت الصفر',
        negativeBody: '{names} صرف هذه النقاط من قبل. سيصبح الرصيد سالبًا.',
        negativeConfirm: 'أعدها رغم ذلك',
        perMember: 'النقاط لكل طفل',
    },
    rewards: {
        title: 'المكافآت',
        savings: 'حصّالات الادخار',
        available: '{count} للصرف',
        reserved: '{count} محجوزة',
        goal: 'يدّخر من أجل',
        noGoal: 'لا هدف ادخار بعد',
        setGoal: 'هدف الادخار',
        goalNone: 'بلا هدف',
        chooseGoal: 'اختر هدفًا للادخار',
        ledger: {
            task_credit: 'مهمة',
            task_reversal: 'أُلغيت المهمة',
            reward_debit: 'مكافأة',
            reward_refund: 'استرداد مكافأة',
            manual_adjustment: 'عدّله أحد الوالدين',
            bonus: 'مكافأة إضافية',
            cleaning_credit: 'تنظيف',
            cleaning_reversal: 'أُلغي التنظيف',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'إنجاز جميل',
            learning_reversal: 'أُلغي إنجاز جميل',
        },
        goalMissing: {
            zero: 'باقي {count} نقطة',
            one: 'باقي نقطة واحدة',
            two: 'باقي نقطتان',
            few: 'باقي {count} نقاط',
            many: 'باقي {count} نقطة',
            other: 'باقي {count} نقطة',
        },
        goalReached: 'تم ادّخار ما يكفي',
        goalSaved: 'تم حفظ هدف الادخار',
        catalogue: 'للادخار من أجلها',
        add: 'مكافأة',
        addLong: 'إضافة مكافأة',
        newTitle: 'مكافأة جديدة',
        editTitle: 'تعديل المكافأة',
        name: 'ماذا',
        namePlaceholder: 'مثلًا: نشتري مثلجات معًا',
        cost: 'كم نجمة؟',
        costHint: 'عدد النجوم التي تكلفها المكافأة (من 1 إلى 9999).',
        costInvalid: 'اختر رقمًا من 1 إلى 9999.',
        forWhom: 'لمن',
        forAll: 'كل من يجمع النقاط',
        limit: 'كم مرة',
        limitNone: 'كلما أردت',
        limitDay: '{count}× في اليوم',
        limitWeek: '{count}× في الأسبوع',
        limitMonth: '{count}× في الشهر',
        stock: 'الكمية',
        stockNone: 'بلا حدود',
        stockLeft: 'باقي {count}',
        created: 'أُضيفت {name}',
        saved: 'تم حفظ المكافأة',
        archive: 'إزالة',
        archiveTitle: 'إزالة {name}؟',
        archiveBody: 'لن يراها الأطفال بعد ذلك. تبقى الطلبات السابقة محفوظة.',
        archived: 'أُزيلت {name}',
        requests: 'الطلبات',
        requestsEmpty: 'لا طلبات مفتوحة.',
        give: 'أعطِ',
        given: 'أُعطيت {name} إلى {member}',
        decline: 'رفض',
        declined: 'رُفض الطلب؛ عادت النقاط',
        adjust: 'تعديل النقاط',
        adjustTitle: 'تعديل النقاط لـ {name}',
        adjustAmount: 'كم',
        adjustAmountHint: 'استخدم علامة الناقص للخصم، مثلًا -5.',
        adjustReason: 'لماذا',
        adjustReasonPlaceholder: 'مثلًا: مساعدة إضافية في الحديقة',
        adjustInvalid: 'اختر رقمًا بين -999 و999 (ليس 0).',
        adjustReasonRequired: 'اكتب السبب باختصار.',
        adjusted: 'رصيد {name} الآن {count}',
        negativeTitle: 'سيصبح الرصيد سالبًا',
        negativeBody: 'بهذا يصبح رصيد {name} تحت الصفر. هل أنت متأكد؟',
        negativeConfirm: 'نعم، عدّل',
        history: 'آخر النقاط',
        historyEmpty: 'لم تُكسب نقاط بعد.',
        pointsOff: 'النقاط مطفأة',
        export: 'تصدير (CSV)',
    },
    approvals: {
        title: 'الموافقات',
        open: 'مفتوح',
        handled: 'تمت معالجتها',
        approve: 'موافقة',
        approved: 'تمت الموافقة على {title}',
        reject: 'رفض',
        rejectTitle: 'رفض {title}؟',
        rejectNote: 'ماذا بقي أن يُفعل؟',
        rejectNotePlaceholder: 'مثلًا: الصحون لم توضع على المائدة بعد',
        rejected: '{title} تعود إلى {name}',
        asks: '{name} يطلب',
        doneAt: 'انتهت الساعة {time}',
        doneAgo: 'انتهت {ago}',
        give: 'أعطِ',
        decline: 'رفض',
        notices: 'من الجيد أن تعرف',
        emptyTitle: 'تمت معالجة كل شيء',
        emptyBody: 'لا شيء ينتظر الموافقة.',
        handledEmpty: 'هنا يظهر ما عالجته.',
        state: {
            fulfilled: 'أُعطيت',
            declined: 'رُفضت',
            cancelled: 'سُحبت',
            expired: 'انتهت صلاحيتها',
            pending: 'مفتوحة',
        },
        together: 'مع {names}',
    },
    members: {
        title: 'العائلة',
        intro: 'كل من يظهر على اللوحة. اللون والوجه يظهران في كل مكان.',
        add: 'فرد',
        addLong: 'إضافة فرد من العائلة',
        newTitle: 'فرد جديد',
        editTitle: 'تعديل {name}',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'استخدم الأسهم لتحديد الترتيب. يسري الترتيب في كل مكان: في التطبيق وعلى اللوحة.',
        moveUp: 'تقديم {name}',
        moveDown: 'تأخير {name}',
        orderNow: '{name} الآن في المرتبة {position} من {count}.',
        orderStale: 'تغيّر شيء في العائلة في الأثناء. أُعيد تحميل القائمة.',
        name: 'الاسم',
        namePlaceholder: 'مثلًا: سامي',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'الأحرف الأولى',
        initialsHint: 'من حرف إلى ثلاثة أحرف. تظهر في التقويم بعد الموعد، مثلًا كرة القدم · A.',
        initialsInvalid: 'أدخل من حرف إلى ثلاثة أحرف.',
        kind: 'من هو',
        kindAdult: 'والد أو والدة',
        kindChild: 'طفل',
        kindHelper: 'جليسة أو مساعد',
        age: 'العمر',
        ageNone: 'لا أعرف',
        ageBands: {
            '0-5': 'حتى 6 سنوات',
            '6-9': '6–9 سنوات',
            '10-12': '10–12 سنة',
            '13-15': '13–15 سنة',
            '16+': '16 سنة فأكثر',
        },
        face: 'الوجه',
        faceNone: 'الحرف الأول',
        preview: 'هكذا يبدو',
        saved: 'تم حفظ {name}',
        created: '{name} الآن من العائلة',
        you: 'أنت',
        points: 'يجمع النقاط',
        inviteTitle: 'ادعُ شريكك',
        inviteBody: 'التخطيط معًا أسهل. أضف شريكك ثم ادعُه عبر البريد الإلكتروني.',
    },
    devices: {
        ...appDevicesG4Ar,
        title: 'الأجهزة اللوحية',
        intro: 'الأجهزة اللوحية التي تعمل عليها لوحة العائلة.',
        add: 'ربط جهاز لوحي',
        online: 'متصل',
        seen: 'آخر ظهور {ago}',
        never: 'لم يظهر أبدًا',
        version: 'الإصدار {version}',
        room: 'الغرفة',
        rename: 'إعادة التسمية',
        renameTitle: 'إعادة تسمية الجهاز',
        revoke: 'فك الربط',
        revokeTitle: 'فك ربط هذا الجهاز؟',
        revokeBody: 'بعدها يعرض {name} رمز ربط من جديد. يمكنك ربطه لاحقًا مرة أخرى.',
        revoked: 'فُك ربط {name}',
        saved: 'تم حفظ الجهاز',
        statusRevoked: 'غير مربوط',
        statusSuspect: 'يحتاج مراجعة',
        emptyTitle: 'اربط الجهاز اللوحي',
        emptyBody: 'افتح لوحة العائلة على الجهاز اللوحي وأدخل الرمز هنا.',
    },
    settings: {
        title: 'الإعدادات',
        household: 'البيت',
        householdName: 'الاسم',
        timezone: 'المنطقة الزمنية',
        wizard: 'إعداد البيت',
        security: 'الأمان',
        securityBody: 'الشبكات والمتصفحات الموثوقة والجلسات.',
        export: 'تصدير الأجندة',
        exportBody: 'نزّل الأجندة كملف .ics، للعائلة كلها أو لكل شخص.',
        exportAll: 'العائلة كلها',
        data: 'تنزيل البيانات',
        dataBody: 'نسخة من بياناتكم في ملف (JSON)، ومنها اختياراتكم في «ما يناسب عائلتنا». تؤكد أولًا بكلمة المرور.',
        dataMine: 'بياناتي',
        dataAll: 'العائلة كلها',
        dataStarted: 'الملف في مجلد التنزيلات.',
        about: 'حول',
        version: 'الإصدار {version}',
        open: 'فتح',
    },
    wizard: {
        step: 'الخطوة {n} من {total}',
        step1Title: 'أهلًا بكم في البيت',
        step1Body: 'نرى الأسبوع معًا، بلا تعب. نبدأ بعائلتك.',
        householdName: 'اسم بيتك',
        householdPlaceholder: 'عائلة الأحمد',
        yourName: 'اسمك على اللوحة',
        yourNameHint: 'مثلًا: بابا أو سارة',
        step2Title: 'من في العائلة؟',
        step2Body: 'أعطِ كل واحد لونًا. ويمكن للطفل أن يختار حيوانًا أيضًا.',
        addMember: 'إضافة شخص آخر',
        memberAdded: 'أُضيف {name}',
        step3Title: 'أول المهام',
        step3Body: 'اختر بعض المهام الثابتة. يمكنك تعديل كل شيء لاحقًا.',
        step3For: 'للأطفال',
        step3Added: {
            zero: 'لم تُضف مهام',
            one: 'أُضيفت مهمة واحدة',
            two: 'أُضيفت مهمتان',
            few: 'أُضيفت {count} مهام',
            many: 'أُضيفت {count} مهمة',
            other: 'أُضيفت {count} مهمة',
        },
        step3NoKids: 'أضف طفلًا أولًا لتعطيه مهام.',
        step4Title: 'اربط الجهاز اللوحي',
        step4Body: 'افتح لوحة العائلة على الجهاز اللوحي في غرفة الجلوس وأدخل الرمز.',
        pairNow: 'ربط الجهاز اللوحي',
        finish: 'تم',
        done: 'بيتك جاهز',
    },
    notFoundTitle: 'هذه الصفحة غير موجودة',
    notFoundBody: 'ربما الرابط قديم. عد إلى اليوم.',
    toToday: 'إلى اليوم',
    crashTitle: 'عذرًا، حدث خطأ',
    crashBody: 'حاول مرة أخرى. إن لم ينجح ذلك، أعد تحميل الصفحة.',
    reload: 'إعادة التحميل',
};
//# sourceMappingURL=app.ar.js.map